/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @file Input component for text input
 * @author Heino Lenting

 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sym-input-text[_ngcontent-%COMP%]   .sym-markdown-output[_ngcontent-%COMP%]{height:125px;overflow:auto;padding:5px 0}.sym-input-text[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{height:125px;resize:none;font-size:80%;line-height:1.5}.sym-input-text[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]:focus{-webkit-box-shadow:none!important;box-shadow:none!important}.sym-input-text[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{text-decoration:underline}"];
export { styles as styles };
